// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

/**
 * This state is for to define master reducer state varibles.
 * For define master reducer state purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially define
 */

// -------------------------------
//  Master State
// -------------------------------
export interface MasterState extends EntityState<any> {
  countryLookUp?: Array<any>;
  timezoneLookUp?: Array<any>;
  stateLookUp?: any;
  countryCodeLookUp?: Array<any>;
  businessLookUp?: Array<any>;
  trainingLicenseLookUp?: Array<any>;
  taskGroupLookup?: Array<any>;
  taskGroupLocationLookup?: Array<any>;
  allStateLookUp: Array<any>;
  currencyLookUp: Array<any>;
}

// -------------------------------
//  Master Adapter
// -------------------------------
export const masterAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Master Initial State
// -------------------------------
export const initialState: MasterState = masterAdapter.getInitialState(
  {
    countryLookUp: [],
    timezoneLookUp: [],
    businessLookUp: [],
    countryCodeLookUp: [],
    stateLookUp: {},
    taskGroupLookup: [],
    taskGroupLocationLookup: [],
    allStateLookUp: [],
    currencyLookUp: [],

  },
);
